import React, { useState, useEffect } from "react";
import { Star, Quote } from "lucide-react";
import { reviewsAPI, handleAPIError } from "../services/api";

const ReviewsSection = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        setLoading(true);
        const response = await reviewsAPI.getAll();
        if (active) setReviews(response.data);
      } catch (err) {
        if (active) setError(handleAPIError(err));
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => { active = false; };
  }, []);

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <Star
        key={`star-${index}`}
        size={16}
        className={index < rating ? "star-filled" : "star-empty"}
        fill={index < rating ? "currentColor" : "none"}
      />
    ));
  };

  if (loading) {
    return (
      <section id="reviews" className="section-padding reviews-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">What Our Customers Say</h2>
            <p className="body-large section-subtitle">
              Hear from those who have experienced our island luxury
            </p>
          </div>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="reviews" className="section-padding reviews-section">
        <div className="container">
          <div className="section-header">
            <h2 className="heading-1">What Our Customers Say</h2>
            <p className="body-large section-subtitle">
              Hear from those who have experienced our island luxury
            </p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="reviews" className="section-padding reviews-section">
      <div className="container">
        <div className="section-header">
          <h2 className="heading-1">What Our Customers Say</h2>
          <p className="body-large section-subtitle">
            Hear from those who have experienced our island luxury
          </p>
        </div>

        <div className="reviews-grid">
          {reviews.map((review) => (
            <div key={review.id} className="review-card">
              <div className="review-header">
                <div className="review-stars">
                  {renderStars(review.rating)}
                </div>
                <Quote className="quote-icon" size={20} />
              </div>
              
              <p className="review-text body-regular">
                "{review.text}"
              </p>
              
              <div className="review-footer">
                <div className="reviewer-info">
                  <span className="reviewer-name">{review.name}</span>
                  <span className="reviewer-location body-small">
                    {review.location}
                  </span>
                </div>
                <div className="reviewed-product">
                  <span className="body-small">{review.product}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="reviews-cta">
          <h3 className="heading-2">Share Your Experience</h3>
          <p className="body-regular">
            We'd love to hear how our products have enhanced your skincare routine.
          </p>
          <a 
            href="mailto:veronica.gella@yahoo.com?subject=Product Review"
            className="btn-secondary"
          >
            Write a Review
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;